import { render } from "./AppointmentViewModal.vue?vue&type=template&id=2cb3ea0c&scoped=true"
import script from "./AppointmentViewModal.vue?vue&type=script&lang=js"
export * from "./AppointmentViewModal.vue?vue&type=script&lang=js"

import "./AppointmentViewModal.vue?vue&type=style&index=0&id=2cb3ea0c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cb3ea0c"]])

export default __exports__